import { Button, Link } from '@mui/joy';
import { useChapterConfig } from '../../hooks/useChapterConfig';

interface ReturnToHomepageButtonProps {
	sx?: object;
	fullWidthOnMobile?: boolean;
}

export const ReturnToHomepageButton = ({
	sx = {},
	fullWidthOnMobile = false
}: ReturnToHomepageButtonProps) => {
	const { getLandingPageUrl, hasLandingPage } = useChapterConfig();

	if (!hasLandingPage) {
		return null;
	}

	const defaultSx = {
		fontSize: '1.125rem',
		paddingY: '14px',
		paddingX: '19px',
		backgroundColor: '#374151',
		color: '#FFFFFF',
		'&:hover': {
			backgroundColor: '#0043B0'
		},
		...(fullWidthOnMobile && { width: { xs: '100%', md: 'auto' } }),
		...sx
	};

	return (
		<Link
			underline='none'
			href={`${getLandingPageUrl()}/`}
			sx={{ ':hover': { textDecoration: 'none' } }}
		>
			<Button variant='solid' sx={defaultSx}>
				Return to Project Homepage
			</Button>
		</Link>
	);
};
